import { WarningIcon } from '@chakra-ui/icons'
import { Flex, Stack, Text } from '@chakra-ui/react'
import { createStandaloneToast } from '@chakra-ui/toast'

const { toast } = createStandaloneToast()

type Status = 'info' | 'warning' | 'success' | 'error' | 'loading'

const buildBasicToast = (title: string, status: Status) => {
  toast.closeAll()

  if (!title) return

  return toast({
    title,
    status,
    variant: 'solid',
    duration: 4000,
    isClosable: true,
    position: 'top-right',
  })
}

const buildToastWithRequesterID = (title: string, requesterId: string, status: Status) => {
  toast.closeAll()

  if (!title) return

  return toast({
    title,
    status,
    variant: 'solid',
    duration: 4000,
    isClosable: true,
    position: 'top-right',
    render: () => (
      <Stack spacing={1} bg="red.600" rounded="md" py={2} px={4}>
        <Flex align="center" justify="flex-start" gap={2}>
          <WarningIcon color="light" boxSize={5} />

          <Text fontWeight="900" color="light" fontSize="lg">
            {title}
          </Text>
        </Flex>

        <Text ps={7} color="light">
          {requesterId}
        </Text>
      </Stack>
    ),
  })
}

const buildToastAPIStandard = (response: any, status: Status) => {
  toast.closeAll()
  if (!response) return

  const title = response?.header?.message || ''
  const requestId = response?.header?.requestId || ''

  return toast({
    title: title,
    status,
    variant: 'solid',
    duration: 4000,
    isClosable: true,
    position: 'top-right',
    render: () => (
      <Stack spacing={1} bg="red.200" rounded="md" py={2} px={4}>
        <Flex align="center" justify="flex-start" gap={2}>
          <WarningIcon color="light" boxSize={5} />
          <Text color="light" fontSize="md">
            {title}
          </Text>
        </Flex>
        <Flex alignItems={'center'} gap={1} borderTop={'1px solid'} borderColor={'light'} pt={2}>
          <Text color="light">Id da requisição:</Text>
          <Flex bg="primary" px={'4px'} py={'2px'} color="light" rounded={'sm'}>
            <Text>{requestId}</Text>
          </Flex>
        </Flex>
      </Stack>
    ),
  })
}

function createToast() {
  const toastManager = {
    error: (title: string) => buildBasicToast(title, 'error'),
    success: (title: string) => buildBasicToast(title, 'success'),
    info: (title: string) => buildBasicToast(title, 'info'),
    warning: (title: string) => buildBasicToast(title, 'warning'),
    errorWithRequesterID: (title: string, id: string) => buildToastWithRequesterID(title, id, 'error'),
    errorAPIStandard: (response: any) => buildToastAPIStandard(response, 'error'),
  }

  return toastManager
}

export default createToast()
